import { Injectable             } from "@angular/core";
import { TimeTrackerBaseApi     } from './generic.service';
import { BehaviorSubject        } from "rxjs/BehaviorSubject";
import { ISwipe                 } from "../../typings/timetracker/timetracker";

@Injectable()
export class SwipeService {

    private swipes$: BehaviorSubject<ISwipe[]> = new BehaviorSubject(null);

    constructor( private $api: TimeTrackerBaseApi ) {}

    /**
     * Retrieve the status of the swipes for each (iso) week for a user
     * @param {number} year
     * @param {number} isoWeek
     */
    dispatchSwipeList( userId: number, year: number, isoWeek: number, limit?: number, skip?: number ) {
      this.$api.genericGetCall( `/admin/users/${userId}/swipes/${year}/${isoWeek}` )
      .subscribe( ( response ) => {
        console.log( '[SWIPES] response', response)
        this.swipes$.next( response as ISwipe[] );
      } );
    }

    /**
     * Select the list of swipes
     */
    selectSwipes() {
      return this.swipes$.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/providers/swipe.service.ts